module.exports = __webpack_public_path__ + "img/product_banner_robot.1675d490.png";